import { useEffect, useState } from 'react';
import { useApi } from '../../lib/api';

type App = {
  application_id: string;
  user_id: string;
  email: string;
  full_name: string | null;
  phone: string | null;
  giants_account_id: string;
  season: string;
  status: string;
  submitted_at: number;
};

export default function AdminApplications() {
  const api = useApi();
  const [apps, setApps] = useState<App[]>([]);
  const [note, setNote] = useState<Record<string, string>>({});

  async function refresh() {
    const { applications } = await api<{ applications: App[] }>('/admin/applications?status=pending');
    setApps(applications);
  }
  useEffect(() => {
    refresh().catch(console.error);
  }, []);

  async function decide(id: string, action: 'approve' | 'reject') {
    await api(`/admin/applications/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ action, note: note[id] ?? '' }),
    });
    await refresh();
  }

  return (
    <section>
      <h2>Seller applications</h2>
      {apps.length === 0 && <p className="muted">No pending applications.</p>}
      <div className="grid cols-3">
        {apps.map((a) => (
          <div className="card" key={a.application_id}>
            <p>
              <strong>{a.full_name ?? '(no name)'}</strong>
            </p>
            <p className="muted">{a.email}</p>
            <p>Giants ID: {a.giants_account_id}</p>
            <p>Season: {a.season}</p>
            <textarea
              placeholder="Admin note (optional)"
              value={note[a.application_id] ?? ''}
              onChange={(e) => setNote({ ...note, [a.application_id]: e.target.value })}
            />
            <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem' }}>
              <button onClick={() => decide(a.application_id, 'approve')}>Approve</button>
              <button
                className="btn-secondary"
                onClick={() => decide(a.application_id, 'reject')}
              >
                Reject
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
